// extracted by mini-css-extract-plugin
export var downArrow = "_am-0";
export var label = "_am-1";
export var treatmentCard = "_am-3";
export var upArrow = "_am-2";